import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import _ from "lodash";
import { AUTH_ROLES } from '../../types/auth.type';

const USER_ROLES = ["editAdt"];
const ADMIN_PERMISSIONS = ["addUser", "editUser", "deleteUser"];
const OWNER_PERMISSIONS = ["addFacility", "editFacility", "deleteFacility", "addUser", "editUser", "deleteUser", "editAdt"];

export const ShowForPermission = ({ children, type }) => {
    const permission = useSelector(state => state.permission);

    if (!permission) {
        return null;
    }

    if (permission.role === AUTH_ROLES.SUPER) {
        return children;
    }

    if (permission.role === AUTH_ROLES.OWNER || permission.role === AUTH_ROLES.TOTAL) {
        if (_.includes(OWNER_PERMISSIONS, type)) {
            return children;
        } else {
            return null;
        }
    }

    if (permission.role === AUTH_ROLES.ADMIN || permission.role === AUTH_ROLES.REGIONAL) {
        if (_.includes(ADMIN_PERMISSIONS, type)) {
            return children;
        } else {
            return null;
        }
    }

    if (permission.role === AUTH_ROLES.USER) {
        if (_.includes(USER_ROLES, type)) {
            return children;
        } else {
            return null;
        }
    }

    return null;
};

ShowForPermission.propTypes = {
    children: PropTypes.node,
    type: PropTypes.string.isRequired
};